import { render, staticRenderFns } from "./customerChild.vue?vue&type=template&id=cdf33a08&scoped=true&"
import script from "./customerChild.vue?vue&type=script&lang=js&"
export * from "./customerChild.vue?vue&type=script&lang=js&"
import style0 from "./customerChild.vue?vue&type=style&index=0&id=cdf33a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf33a08",
  null
  
)

export default component.exports